export const setLayout = layout => (dispatch, getState) => {
  dispatch({ type: "SET_LAYOUT", payload: layout });
};
